export default __webpack_public_path__ + "static/media/EN_10.daa7db95.svg";